import styled from "@emotion/styled";
import { css } from "@emotion/react";
import Select from "react-select";
import {
    breakpoints,
    colors,
    colorVariables,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
    mediaQuery,
    boxSizes,
} from "@gumtree/ui-library/src/base/theme";
import { Dialog, Icon } from "@gumtree/ui-library";

export const StyledOptionContainer = styled.div`
    position: relative;
`;

export const StyledIcon = styled(Icon)`
    position: absolute;
    top: ${gutterSizes.medium10};
    left: ${gutterSizes.small};
    transform: scale(0.7);
`;

export const StyledDialog = styled(Dialog)<{
    isMobile: boolean;
}>`
    border-radius: 8px;

    ${({ isMobile }) =>
        isMobile
            ? `
height: 100vh;
min-width: 100%;
`
            : `
width: 620px;
`}
    padding: 0;

    ${mediaQuery.until(breakpoints.xsmall)} {
        min-width: 320px;
    }

    .dialog-title {
        border-bottom: 1px solid ${colorVariables.borderLight};
        font-size: ${fontSizes.header};
        padding: 20px 0 20px ${gutterSizes.large};
        margin: 0 0 ${gutterSizes.small};
    }

    .dialog-close {
        height: 42px;
        width: 42px;
        margin-top: 13px;
        margin-right: 17px;

        .icon {
            color: ${colors.bark80};
            font-weight: ${fontWeights.normal};
        }
    }
`;

export const modalButtonsCss = css`
    border-top: 1px solid ${colorVariables.borderLight};
    display: flex;
    justify-content: flex-end;
    padding: ${gutterSizes.large};

    > button {
        height: 38px;
    }

    .close-button {
        border-color: unset;
    }

    .update-button {
        margin-left: ${gutterSizes.base};
    }
`;

export const SearchLocation = styled.div`
    display: flex;
    flex-direction: row;
    color: ${colorVariables.textLink};
    margin-top: ${gutterSizes.medium};
    max-width: max-content;

    &:hover {
        cursor: pointer;
    }
`;

export const StyledDialogBody = styled.div`
    padding: ${gutterSizes.large};

    .full-update-button {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: ${gutterSizes.xxlarge};
        width: 100%;
    }
`;

export const StyledLocationBlock = styled.div`
    position: relative;
    margin-bottom: ${gutterSizes.large};

    .location-input-icon {
        position: absolute;
        left: ${gutterSizes.medium};
        top: ${gutterSizes.medium};
        z-index: 11;
        color: ${colors.bark80};
        font-size: ${fontSizes.large};
    }

    .form-element {
        border: 2px solid transparent;
        border-radius: 8px;

        &:focus-within {
            border: 2px solid ${colors.gtallBlue};
        }

        .button {
            display: flex;
            justify-content: center;
            width: 38px;
            height: 38px;
            box-sizing: content-box;
            padding: 0;

            .icon {
                color: ${colors.bark80};
            }
        }
    }

    & input {
        border-radius: 4px;
        border-color: ${colors.bark40};
        font-size: ${fontSizes.medium};
        height: 38px;
        padding-left: 40px;
    }
`;

export const StyledSearchResults = styled.div`
    margin-bottom: ${gutterSizes.medium};
`;

export const StyledLocationItem = styled.div`
    display: flex;
    font-size: ${fontSizes.base};
    line-height: ${lineHeights.base};
    padding: ${gutterSizes.medium10};

    .location-search-icon {
        margin-right: ${gutterSizes.medium};
        color: ${colors.bark80};
        font-size: ${fontSizes.large};
    }

    &:hover {
        cursor: pointer;
        background-color: ${colors.surface};
    }
`;

export const StyledInputLabel = styled.div`
    font-size: ${fontSizes.small};
    line-height: ${lineHeights.small};
    margin-bottom: ${gutterSizes.small};
`;

export const StyledSelect = styled(Select)`
    &:focus-within {
        padding: 1px;
        border: 2px solid ${colors.gtallBlue};
        border-radius: ${boxSizes.borderRadius4};
    }

    .react-select__indicator-separator {
        display: none;
    }

    .react-select__control {
        border-color: ${colors.bark40};
        box-shadow: none;

        &:hover {
            border-color: ${colorVariables.textSecondary};
        }
    }

    .react-select__menu {
        border-radius: ${gutterSizes.large};
    }

    .react-select__menu-list {
        background-color: #f5f4f5;
        padding: 0;
        border-radius: ${gutterSizes.large};
    }

    .react-select__option {
        padding-left: ${gutterSizes.xlarge};
        border-bottom: 1px solid ${colorVariables.borderLight};
    }

    .react-select__option--is-focused {
        cursor: pointer;
        background-color: ${colors.bark10};
    }

    .react-select__option--is-selected {
        background-color: transparent;
        color: inherit;
    }

    .react-select__indicator {
        color: ${colors.bark80};
    }
`;

export const LocationIcon = styled.div`
    display: flex;
    align-items: center;
    margin: 0;
    height: 20px;
    width: 20px;
`;

export const LocationTitle = styled.div`
    font-weight: ${fontWeights.lightBold};
    font-size: ${fontSizes.base};
`;
